module.exports = {"370611001":"清洋街道","370611002":"福新街道","370611006":"东厅街道","370611007":"门楼街道","370611102":"高疃镇","370611103":"张格庄镇","370611104":"回里镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370611.json
// module id = 1399
// module chunks = 0